import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

const VUEX_PROPERTIES = ['state', 'getters', 'actions', 'mutations']

let store = {};

(function updateModules () {
  store = normalizeRoot(require('../store/index.js'), 'store/index.js')

  // If store is an exported method = classic mode (deprecated)

  // Enforce store modules
  store.modules = store.modules || {}

  resolveStoreModules(require('../store/particles/step/index.js'), 'particles/step/index.js')
  resolveStoreModules(require('../store/particles/province/index.js'), 'particles/province/index.js')
  resolveStoreModules(require('../store/particles/builder/index.js'), 'particles/builder/index.js')
  resolveStoreModules(require('../store/frontend/work/index.js'), 'frontend/work/index.js')
  resolveStoreModules(require('../store/frontend/user/index.js'), 'frontend/user/index.js')
  resolveStoreModules(require('../store/frontend/todo/index.js'), 'frontend/todo/index.js')
  resolveStoreModules(require('../store/frontend/templates/index.js'), 'frontend/templates/index.js')
  resolveStoreModules(require('../store/frontend/tags/index.js'), 'frontend/tags/index.js')
  resolveStoreModules(require('../store/frontend/setting/index.js'), 'frontend/setting/index.js')
  resolveStoreModules(require('../store/frontend/requestEbooks/index.js'), 'frontend/requestEbooks/index.js')
  resolveStoreModules(require('../store/frontend/proposals/index.js'), 'frontend/proposals/index.js')
  resolveStoreModules(require('../store/frontend/plan/index.js'), 'frontend/plan/index.js')
  resolveStoreModules(require('../store/frontend/papers/index.js'), 'frontend/papers/index.js')
  resolveStoreModules(require('../store/frontend/historyRouter/index.js'), 'frontend/historyRouter/index.js')
  resolveStoreModules(require('../store/frontend/helper/index.js'), 'frontend/helper/index.js')
  resolveStoreModules(require('../store/frontend/group/index.js'), 'frontend/group/index.js')
  resolveStoreModules(require('../store/frontend/documents/index.js'), 'frontend/documents/index.js')
  resolveStoreModules(require('../store/frontend/documentCategories/index.js'), 'frontend/documentCategories/index.js')
  resolveStoreModules(require('../store/frontend/documentApprove/index.js'), 'frontend/documentApprove/index.js')
  resolveStoreModules(require('../store/frontend/chat/index.js'), 'frontend/chat/index.js')
  resolveStoreModules(require('../store/frontend/calendar/index.js'), 'frontend/calendar/index.js')
  resolveStoreModules(require('../store/frontend/auth/index.js'), 'frontend/auth/index.js')
  resolveStoreModules(require('../store/frontend/applications/index.js'), 'frontend/applications/index.js')
  resolveStoreModules(require('../store/frontend/appCategories/index.js'), 'frontend/appCategories/index.js')
  resolveStoreModules(require('../store/admin/works/index.js'), 'admin/works/index.js')
  resolveStoreModules(require('../store/admin/users/index.js'), 'admin/users/index.js')
  resolveStoreModules(require('../store/admin/types/index.js'), 'admin/types/index.js')
  resolveStoreModules(require('../store/admin/transferRequest/index.js'), 'admin/transferRequest/index.js')
  resolveStoreModules(require('../store/admin/transactions/index.js'), 'admin/transactions/index.js')
  resolveStoreModules(require('../store/admin/tool/index.js'), 'admin/tool/index.js')
  resolveStoreModules(require('../store/admin/templates/index.js'), 'admin/templates/index.js')
  resolveStoreModules(require('../store/admin/tags/index.js'), 'admin/tags/index.js')
  resolveStoreModules(require('../store/admin/requestEbooks/index.js'), 'admin/requestEbooks/index.js')
  resolveStoreModules(require('../store/admin/proposals/index.js'), 'admin/proposals/index.js')
  resolveStoreModules(require('../store/admin/plans/index.js'), 'admin/plans/index.js')
  resolveStoreModules(require('../store/admin/papers/index.js'), 'admin/papers/index.js')
  resolveStoreModules(require('../store/admin/mstFields/index.js'), 'admin/mstFields/index.js')
  resolveStoreModules(require('../store/admin/metas/index.js'), 'admin/metas/index.js')
  resolveStoreModules(require('../store/admin/metaGroups/index.js'), 'admin/metaGroups/index.js')
  resolveStoreModules(require('../store/admin/documentTemplates/index.js'), 'admin/documentTemplates/index.js')
  resolveStoreModules(require('../store/admin/contacts/index.js'), 'admin/contacts/index.js')
  resolveStoreModules(require('../store/admin/companies/index.js'), 'admin/companies/index.js')
  resolveStoreModules(require('../store/admin/categories/index.js'), 'admin/categories/index.js')
  resolveStoreModules(require('../store/admin/calendar/index.js'), 'admin/calendar/index.js')
  resolveStoreModules(require('../store/admin/auth/index.js'), 'admin/auth/index.js')
  resolveStoreModules(require('../store/admin/appUserCampaigns/index.js'), 'admin/appUserCampaigns/index.js')
  resolveStoreModules(require('../store/admin/appTags/index.js'), 'admin/appTags/index.js')
  resolveStoreModules(require('../store/admin/appOptions/index.js'), 'admin/appOptions/index.js')
  resolveStoreModules(require('../store/admin/appModals/index.js'), 'admin/appModals/index.js')
  resolveStoreModules(require('../store/admin/applications/index.js'), 'admin/applications/index.js')
  resolveStoreModules(require('../store/admin/appCategories/index.js'), 'admin/appCategories/index.js')
  resolveStoreModules(require('../store/admin/appCategories/actions.js'), 'admin/appCategories/actions.js')
  resolveStoreModules(require('../store/admin/appCategories/getters.js'), 'admin/appCategories/getters.js')
  resolveStoreModules(require('../store/admin/appCategories/mutations.js'), 'admin/appCategories/mutations.js')
  resolveStoreModules(require('../store/admin/appCategories/state.js'), 'admin/appCategories/state.js')
  resolveStoreModules(require('../store/admin/applications/actions.js'), 'admin/applications/actions.js')
  resolveStoreModules(require('../store/admin/applications/getters.js'), 'admin/applications/getters.js')
  resolveStoreModules(require('../store/admin/applications/mutations.js'), 'admin/applications/mutations.js')
  resolveStoreModules(require('../store/admin/applications/state.js'), 'admin/applications/state.js')
  resolveStoreModules(require('../store/admin/appModals/actions.js'), 'admin/appModals/actions.js')
  resolveStoreModules(require('../store/admin/appModals/getters.js'), 'admin/appModals/getters.js')
  resolveStoreModules(require('../store/admin/appModals/mutations.js'), 'admin/appModals/mutations.js')
  resolveStoreModules(require('../store/admin/appModals/state.js'), 'admin/appModals/state.js')
  resolveStoreModules(require('../store/admin/appOptions/actions.js'), 'admin/appOptions/actions.js')
  resolveStoreModules(require('../store/admin/appOptions/mutations.js'), 'admin/appOptions/mutations.js')
  resolveStoreModules(require('../store/admin/appOptions/state.js'), 'admin/appOptions/state.js')
  resolveStoreModules(require('../store/admin/appTags/actions.js'), 'admin/appTags/actions.js')
  resolveStoreModules(require('../store/admin/appTags/getters.js'), 'admin/appTags/getters.js')
  resolveStoreModules(require('../store/admin/appTags/mutations.js'), 'admin/appTags/mutations.js')
  resolveStoreModules(require('../store/admin/appTags/state.js'), 'admin/appTags/state.js')
  resolveStoreModules(require('../store/admin/appUserCampaigns/actions.js'), 'admin/appUserCampaigns/actions.js')
  resolveStoreModules(require('../store/admin/appUserCampaigns/getters.js'), 'admin/appUserCampaigns/getters.js')
  resolveStoreModules(require('../store/admin/appUserCampaigns/mutations.js'), 'admin/appUserCampaigns/mutations.js')
  resolveStoreModules(require('../store/admin/appUserCampaigns/state.js'), 'admin/appUserCampaigns/state.js')
  resolveStoreModules(require('../store/admin/auth/actions.js'), 'admin/auth/actions.js')
  resolveStoreModules(require('../store/admin/auth/getters.js'), 'admin/auth/getters.js')
  resolveStoreModules(require('../store/admin/auth/mutations.js'), 'admin/auth/mutations.js')
  resolveStoreModules(require('../store/admin/auth/state.js'), 'admin/auth/state.js')
  resolveStoreModules(require('../store/admin/calendar/actions.js'), 'admin/calendar/actions.js')
  resolveStoreModules(require('../store/admin/calendar/getters.js'), 'admin/calendar/getters.js')
  resolveStoreModules(require('../store/admin/calendar/mutations.js'), 'admin/calendar/mutations.js')
  resolveStoreModules(require('../store/admin/calendar/state.js'), 'admin/calendar/state.js')
  resolveStoreModules(require('../store/admin/categories/actions.js'), 'admin/categories/actions.js')
  resolveStoreModules(require('../store/admin/categories/getters.js'), 'admin/categories/getters.js')
  resolveStoreModules(require('../store/admin/categories/mutations.js'), 'admin/categories/mutations.js')
  resolveStoreModules(require('../store/admin/categories/state.js'), 'admin/categories/state.js')
  resolveStoreModules(require('../store/admin/companies/actions.js'), 'admin/companies/actions.js')
  resolveStoreModules(require('../store/admin/companies/getters.js'), 'admin/companies/getters.js')
  resolveStoreModules(require('../store/admin/companies/mutations.js'), 'admin/companies/mutations.js')
  resolveStoreModules(require('../store/admin/companies/state.js'), 'admin/companies/state.js')
  resolveStoreModules(require('../store/admin/contacts/actions.js'), 'admin/contacts/actions.js')
  resolveStoreModules(require('../store/admin/contacts/getters.js'), 'admin/contacts/getters.js')
  resolveStoreModules(require('../store/admin/contacts/mutations.js'), 'admin/contacts/mutations.js')
  resolveStoreModules(require('../store/admin/contacts/state.js'), 'admin/contacts/state.js')
  resolveStoreModules(require('../store/admin/documentTemplates/actions.js'), 'admin/documentTemplates/actions.js')
  resolveStoreModules(require('../store/admin/documentTemplates/getters.js'), 'admin/documentTemplates/getters.js')
  resolveStoreModules(require('../store/admin/documentTemplates/mutations.js'), 'admin/documentTemplates/mutations.js')
  resolveStoreModules(require('../store/admin/documentTemplates/state.js'), 'admin/documentTemplates/state.js')
  resolveStoreModules(require('../store/admin/metaGroups/actions.js'), 'admin/metaGroups/actions.js')
  resolveStoreModules(require('../store/admin/metaGroups/getters.js'), 'admin/metaGroups/getters.js')
  resolveStoreModules(require('../store/admin/metaGroups/mutations.js'), 'admin/metaGroups/mutations.js')
  resolveStoreModules(require('../store/admin/metaGroups/state.js'), 'admin/metaGroups/state.js')
  resolveStoreModules(require('../store/admin/metas/actions.js'), 'admin/metas/actions.js')
  resolveStoreModules(require('../store/admin/metas/getters.js'), 'admin/metas/getters.js')
  resolveStoreModules(require('../store/admin/metas/mutations.js'), 'admin/metas/mutations.js')
  resolveStoreModules(require('../store/admin/metas/state.js'), 'admin/metas/state.js')
  resolveStoreModules(require('../store/admin/mstFields/actions.js'), 'admin/mstFields/actions.js')
  resolveStoreModules(require('../store/admin/mstFields/getters.js'), 'admin/mstFields/getters.js')
  resolveStoreModules(require('../store/admin/mstFields/mutations.js'), 'admin/mstFields/mutations.js')
  resolveStoreModules(require('../store/admin/mstFields/state.js'), 'admin/mstFields/state.js')
  resolveStoreModules(require('../store/admin/papers/actions.js'), 'admin/papers/actions.js')
  resolveStoreModules(require('../store/admin/papers/getters.js'), 'admin/papers/getters.js')
  resolveStoreModules(require('../store/admin/papers/mutations.js'), 'admin/papers/mutations.js')
  resolveStoreModules(require('../store/admin/papers/state.js'), 'admin/papers/state.js')
  resolveStoreModules(require('../store/admin/plans/actions.js'), 'admin/plans/actions.js')
  resolveStoreModules(require('../store/admin/plans/getters.js'), 'admin/plans/getters.js')
  resolveStoreModules(require('../store/admin/plans/mutations.js'), 'admin/plans/mutations.js')
  resolveStoreModules(require('../store/admin/plans/state.js'), 'admin/plans/state.js')
  resolveStoreModules(require('../store/admin/proposals/actions.js'), 'admin/proposals/actions.js')
  resolveStoreModules(require('../store/admin/proposals/getters.js'), 'admin/proposals/getters.js')
  resolveStoreModules(require('../store/admin/proposals/mutations.js'), 'admin/proposals/mutations.js')
  resolveStoreModules(require('../store/admin/proposals/state.js'), 'admin/proposals/state.js')
  resolveStoreModules(require('../store/admin/requestEbooks/actions.js'), 'admin/requestEbooks/actions.js')
  resolveStoreModules(require('../store/admin/requestEbooks/getters.js'), 'admin/requestEbooks/getters.js')
  resolveStoreModules(require('../store/admin/requestEbooks/mutations.js'), 'admin/requestEbooks/mutations.js')
  resolveStoreModules(require('../store/admin/requestEbooks/state.js'), 'admin/requestEbooks/state.js')
  resolveStoreModules(require('../store/admin/tags/actions.js'), 'admin/tags/actions.js')
  resolveStoreModules(require('../store/admin/tags/getters.js'), 'admin/tags/getters.js')
  resolveStoreModules(require('../store/admin/tags/mutations.js'), 'admin/tags/mutations.js')
  resolveStoreModules(require('../store/admin/tags/state.js'), 'admin/tags/state.js')
  resolveStoreModules(require('../store/admin/templates/actions.js'), 'admin/templates/actions.js')
  resolveStoreModules(require('../store/admin/templates/getters.js'), 'admin/templates/getters.js')
  resolveStoreModules(require('../store/admin/templates/mutations.js'), 'admin/templates/mutations.js')
  resolveStoreModules(require('../store/admin/templates/state.js'), 'admin/templates/state.js')
  resolveStoreModules(require('../store/admin/tool/actions.js'), 'admin/tool/actions.js')
  resolveStoreModules(require('../store/admin/tool/getters.js'), 'admin/tool/getters.js')
  resolveStoreModules(require('../store/admin/tool/mutations.js'), 'admin/tool/mutations.js')
  resolveStoreModules(require('../store/admin/tool/state.js'), 'admin/tool/state.js')
  resolveStoreModules(require('../store/admin/transactions/actions.js'), 'admin/transactions/actions.js')
  resolveStoreModules(require('../store/admin/transactions/mutations.js'), 'admin/transactions/mutations.js')
  resolveStoreModules(require('../store/admin/transactions/state.js'), 'admin/transactions/state.js')
  resolveStoreModules(require('../store/admin/types/actions.js'), 'admin/types/actions.js')
  resolveStoreModules(require('../store/admin/types/getters.js'), 'admin/types/getters.js')
  resolveStoreModules(require('../store/admin/types/mutations.js'), 'admin/types/mutations.js')
  resolveStoreModules(require('../store/admin/types/state.js'), 'admin/types/state.js')
  resolveStoreModules(require('../store/admin/users/actions.js'), 'admin/users/actions.js')
  resolveStoreModules(require('../store/admin/users/getters.js'), 'admin/users/getters.js')
  resolveStoreModules(require('../store/admin/users/mutations.js'), 'admin/users/mutations.js')
  resolveStoreModules(require('../store/admin/users/state.js'), 'admin/users/state.js')
  resolveStoreModules(require('../store/admin/works/actions.js'), 'admin/works/actions.js')
  resolveStoreModules(require('../store/admin/works/getters.js'), 'admin/works/getters.js')
  resolveStoreModules(require('../store/admin/works/mutations.js'), 'admin/works/mutations.js')
  resolveStoreModules(require('../store/admin/works/state.js'), 'admin/works/state.js')
  resolveStoreModules(require('../store/frontend/appCategories/actions.js'), 'frontend/appCategories/actions.js')
  resolveStoreModules(require('../store/frontend/appCategories/getters.js'), 'frontend/appCategories/getters.js')
  resolveStoreModules(require('../store/frontend/appCategories/mutations.js'), 'frontend/appCategories/mutations.js')
  resolveStoreModules(require('../store/frontend/appCategories/state.js'), 'frontend/appCategories/state.js')
  resolveStoreModules(require('../store/frontend/applications/actions.js'), 'frontend/applications/actions.js')
  resolveStoreModules(require('../store/frontend/applications/getters.js'), 'frontend/applications/getters.js')
  resolveStoreModules(require('../store/frontend/applications/mutations.js'), 'frontend/applications/mutations.js')
  resolveStoreModules(require('../store/frontend/applications/state.js'), 'frontend/applications/state.js')
  resolveStoreModules(require('../store/frontend/auth/actions.js'), 'frontend/auth/actions.js')
  resolveStoreModules(require('../store/frontend/auth/getters.js'), 'frontend/auth/getters.js')
  resolveStoreModules(require('../store/frontend/auth/mutations.js'), 'frontend/auth/mutations.js')
  resolveStoreModules(require('../store/frontend/auth/state.js'), 'frontend/auth/state.js')
  resolveStoreModules(require('../store/frontend/calendar/actions.js'), 'frontend/calendar/actions.js')
  resolveStoreModules(require('../store/frontend/calendar/getters.js'), 'frontend/calendar/getters.js')
  resolveStoreModules(require('../store/frontend/calendar/mutations.js'), 'frontend/calendar/mutations.js')
  resolveStoreModules(require('../store/frontend/calendar/state.js'), 'frontend/calendar/state.js')
  resolveStoreModules(require('../store/frontend/documentApprove/actions.js'), 'frontend/documentApprove/actions.js')
  resolveStoreModules(require('../store/frontend/documentApprove/getters.js'), 'frontend/documentApprove/getters.js')
  resolveStoreModules(require('../store/frontend/documentApprove/mutations.js'), 'frontend/documentApprove/mutations.js')
  resolveStoreModules(require('../store/frontend/documentApprove/state.js'), 'frontend/documentApprove/state.js')
  resolveStoreModules(require('../store/frontend/documentCategories/actions.js'), 'frontend/documentCategories/actions.js')
  resolveStoreModules(require('../store/frontend/documentCategories/getters.js'), 'frontend/documentCategories/getters.js')
  resolveStoreModules(require('../store/frontend/documentCategories/mutations.js'), 'frontend/documentCategories/mutations.js')
  resolveStoreModules(require('../store/frontend/documentCategories/state.js'), 'frontend/documentCategories/state.js')
  resolveStoreModules(require('../store/frontend/documents/actions.js'), 'frontend/documents/actions.js')
  resolveStoreModules(require('../store/frontend/documents/getters.js'), 'frontend/documents/getters.js')
  resolveStoreModules(require('../store/frontend/documents/mutations.js'), 'frontend/documents/mutations.js')
  resolveStoreModules(require('../store/frontend/documents/state.js'), 'frontend/documents/state.js')
  resolveStoreModules(require('../store/frontend/group/actions.js'), 'frontend/group/actions.js')
  resolveStoreModules(require('../store/frontend/group/getters.js'), 'frontend/group/getters.js')
  resolveStoreModules(require('../store/frontend/group/mutations.js'), 'frontend/group/mutations.js')
  resolveStoreModules(require('../store/frontend/group/state.js'), 'frontend/group/state.js')
  resolveStoreModules(require('../store/frontend/helper/actions.js'), 'frontend/helper/actions.js')
  resolveStoreModules(require('../store/frontend/helper/getters.js'), 'frontend/helper/getters.js')
  resolveStoreModules(require('../store/frontend/helper/mutations.js'), 'frontend/helper/mutations.js')
  resolveStoreModules(require('../store/frontend/helper/state.js'), 'frontend/helper/state.js')
  resolveStoreModules(require('../store/frontend/historyRouter/actions.js'), 'frontend/historyRouter/actions.js')
  resolveStoreModules(require('../store/frontend/historyRouter/getters.js'), 'frontend/historyRouter/getters.js')
  resolveStoreModules(require('../store/frontend/historyRouter/mutations.js'), 'frontend/historyRouter/mutations.js')
  resolveStoreModules(require('../store/frontend/historyRouter/state.js'), 'frontend/historyRouter/state.js')
  resolveStoreModules(require('../store/frontend/papers/actions.js'), 'frontend/papers/actions.js')
  resolveStoreModules(require('../store/frontend/papers/getters.js'), 'frontend/papers/getters.js')
  resolveStoreModules(require('../store/frontend/papers/mutations.js'), 'frontend/papers/mutations.js')
  resolveStoreModules(require('../store/frontend/papers/state.js'), 'frontend/papers/state.js')
  resolveStoreModules(require('../store/frontend/plan/actions.js'), 'frontend/plan/actions.js')
  resolveStoreModules(require('../store/frontend/plan/getters.js'), 'frontend/plan/getters.js')
  resolveStoreModules(require('../store/frontend/plan/mutations.js'), 'frontend/plan/mutations.js')
  resolveStoreModules(require('../store/frontend/plan/state.js'), 'frontend/plan/state.js')
  resolveStoreModules(require('../store/frontend/proposals/actions.js'), 'frontend/proposals/actions.js')
  resolveStoreModules(require('../store/frontend/proposals/getters.js'), 'frontend/proposals/getters.js')
  resolveStoreModules(require('../store/frontend/proposals/mutations.js'), 'frontend/proposals/mutations.js')
  resolveStoreModules(require('../store/frontend/proposals/state.js'), 'frontend/proposals/state.js')
  resolveStoreModules(require('../store/frontend/requestEbooks/actions.js'), 'frontend/requestEbooks/actions.js')
  resolveStoreModules(require('../store/frontend/requestEbooks/getters.js'), 'frontend/requestEbooks/getters.js')
  resolveStoreModules(require('../store/frontend/requestEbooks/mutations.js'), 'frontend/requestEbooks/mutations.js')
  resolveStoreModules(require('../store/frontend/requestEbooks/state.js'), 'frontend/requestEbooks/state.js')
  resolveStoreModules(require('../store/frontend/setting/actions.js'), 'frontend/setting/actions.js')
  resolveStoreModules(require('../store/frontend/setting/getters.js'), 'frontend/setting/getters.js')
  resolveStoreModules(require('../store/frontend/setting/mutations.js'), 'frontend/setting/mutations.js')
  resolveStoreModules(require('../store/frontend/setting/state.js'), 'frontend/setting/state.js')
  resolveStoreModules(require('../store/frontend/tags/actions.js'), 'frontend/tags/actions.js')
  resolveStoreModules(require('../store/frontend/tags/getters.js'), 'frontend/tags/getters.js')
  resolveStoreModules(require('../store/frontend/tags/mutations.js'), 'frontend/tags/mutations.js')
  resolveStoreModules(require('../store/frontend/tags/state.js'), 'frontend/tags/state.js')
  resolveStoreModules(require('../store/frontend/templates/actions.js'), 'frontend/templates/actions.js')
  resolveStoreModules(require('../store/frontend/templates/getters.js'), 'frontend/templates/getters.js')
  resolveStoreModules(require('../store/frontend/templates/mutations.js'), 'frontend/templates/mutations.js')
  resolveStoreModules(require('../store/frontend/templates/state.js'), 'frontend/templates/state.js')
  resolveStoreModules(require('../store/frontend/todo/actions.js'), 'frontend/todo/actions.js')
  resolveStoreModules(require('../store/frontend/todo/getters.js'), 'frontend/todo/getters.js')
  resolveStoreModules(require('../store/frontend/todo/mutations.js'), 'frontend/todo/mutations.js')
  resolveStoreModules(require('../store/frontend/todo/state.js'), 'frontend/todo/state.js')
  resolveStoreModules(require('../store/frontend/user/actions.js'), 'frontend/user/actions.js')
  resolveStoreModules(require('../store/frontend/user/getters.js'), 'frontend/user/getters.js')
  resolveStoreModules(require('../store/frontend/user/mutations.js'), 'frontend/user/mutations.js')
  resolveStoreModules(require('../store/frontend/user/state.js'), 'frontend/user/state.js')
  resolveStoreModules(require('../store/frontend/work/actions.js'), 'frontend/work/actions.js')
  resolveStoreModules(require('../store/frontend/work/getters.js'), 'frontend/work/getters.js')
  resolveStoreModules(require('../store/frontend/work/mutations.js'), 'frontend/work/mutations.js')
  resolveStoreModules(require('../store/frontend/work/state.js'), 'frontend/work/state.js')
  resolveStoreModules(require('../store/particles/builder/actions.js'), 'particles/builder/actions.js')
  resolveStoreModules(require('../store/particles/builder/getters.js'), 'particles/builder/getters.js')
  resolveStoreModules(require('../store/particles/builder/mutations.js'), 'particles/builder/mutations.js')
  resolveStoreModules(require('../store/particles/builder/state.js'), 'particles/builder/state.js')
  resolveStoreModules(require('../store/particles/province/actions.js'), 'particles/province/actions.js')
  resolveStoreModules(require('../store/particles/province/getters.js'), 'particles/province/getters.js')
  resolveStoreModules(require('../store/particles/province/mutations.js'), 'particles/province/mutations.js')
  resolveStoreModules(require('../store/particles/province/state.js'), 'particles/province/state.js')
  resolveStoreModules(require('../store/particles/step/actions.js'), 'particles/step/actions.js')
  resolveStoreModules(require('../store/particles/step/getters.js'), 'particles/step/getters.js')
  resolveStoreModules(require('../store/particles/step/mutations.js'), 'particles/step/mutations.js')
  resolveStoreModules(require('../store/particles/step/state.js'), 'particles/step/state.js')

  // If the environment supports hot reloading...
})()

// createStore
export const createStore = store instanceof Function ? store : () => {
  return new Vuex.Store(Object.assign({
    strict: (process.env.NODE_ENV !== 'production')
  }, store))
}

function normalizeRoot (moduleData, filePath) {
  moduleData = moduleData.default || moduleData

  if (moduleData.commit) {
    throw new Error(`[nuxt] ${filePath} should export a method that returns a Vuex instance.`)
  }

  if (typeof moduleData !== 'function') {
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData)
  }
  return normalizeModule(moduleData, filePath)
}

function normalizeModule (moduleData, filePath) {
  if (moduleData.state && typeof moduleData.state !== 'function') {
    console.warn(`'state' should be a method that returns an object in ${filePath}`)

    const state = Object.assign({}, moduleData.state)
    // Avoid TypeError: setting a property that has only a getter when overwriting top level keys
    moduleData = Object.assign({}, moduleData, { state: () => state })
  }
  return moduleData
}

function resolveStoreModules (moduleData, filename) {
  moduleData = moduleData.default || moduleData
  // Remove store src + extension (./foo/index.js -> foo/index)
  const namespace = filename.replace(/\.(js|mjs)$/, '')
  const namespaces = namespace.split('/')
  let moduleName = namespaces[namespaces.length - 1]
  const filePath = `store/${filename}`

  moduleData = moduleName === 'state'
    ? normalizeState(moduleData, filePath)
    : normalizeModule(moduleData, filePath)

  // If src is a known Vuex property
  if (VUEX_PROPERTIES.includes(moduleName)) {
    const property = moduleName
    const propertyStoreModule = getStoreModule(store, namespaces, { isProperty: true })

    // Replace state since it's a function
    mergeProperty(propertyStoreModule, moduleData, property)
    return
  }

  // If file is foo/index.js, it should be saved as foo
  const isIndexModule = (moduleName === 'index')
  if (isIndexModule) {
    namespaces.pop()
    moduleName = namespaces[namespaces.length - 1]
  }

  const storeModule = getStoreModule(store, namespaces)

  for (const property of VUEX_PROPERTIES) {
    mergeProperty(storeModule, moduleData[property], property)
  }

  if (moduleData.namespaced === false) {
    delete storeModule.namespaced
  }
}

function normalizeState (moduleData, filePath) {
  if (typeof moduleData !== 'function') {
    console.warn(`${filePath} should export a method that returns an object`)
    const state = Object.assign({}, moduleData)
    return () => state
  }
  return normalizeModule(moduleData, filePath)
}

function getStoreModule (storeModule, namespaces, { isProperty = false } = {}) {
  // If ./mutations.js
  if (!namespaces.length || (isProperty && namespaces.length === 1)) {
    return storeModule
  }

  const namespace = namespaces.shift()

  storeModule.modules[namespace] = storeModule.modules[namespace] || {}
  storeModule.modules[namespace].namespaced = true
  storeModule.modules[namespace].modules = storeModule.modules[namespace].modules || {}

  return getStoreModule(storeModule.modules[namespace], namespaces, { isProperty })
}

function mergeProperty (storeModule, moduleData, property) {
  if (!moduleData) {
    return
  }

  if (property === 'state') {
    storeModule.state = moduleData || storeModule.state
  } else {
    storeModule[property] = Object.assign({}, storeModule[property], moduleData)
  }
}
